import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap'; // Import Bootstrap components
// import './Review.css'; // Ensure this CSS file includes the new styles
import { useUser } from '../../../../UserContext';
import { getReviewsByVendor, respondToReview } from '../../../API_Handler';
import ProfileNavBar from '../ProfileNavBar/ProfileNavBar';
import { useToast } from '../../../../Common/ToastContext';
import SearchBar from '../SearchBar/SearchBar';

const Reviews = () => {
    const showToast = useToast();
    const { userReviews, setUserReviews } = useUser();
    const [selectedProductId, setSelectedProductId] = useState(null); // To store the selected product's ID
    const [productList, setProductList] = useState([]); // To store the list of products for filtering
    const [reviewsData, setReviewsData] = useState([]); // Reviews filtered by selected product
    const [searchQuery, setSearchQuery] = useState(''); // To handle search queries
    const [showReplyModal, setShowReplyModal] = useState(false); // Modal visibility
    const [selectedReview, setSelectedReview] = useState(null); // To track the review being replied to
    const [replyText, setReplyText] = useState(''); // To store the reply text



    useEffect(() => {
        if (userReviews) {
            setReviewsData(userReviews);
            getProductList();
            return;
        }

        // const fetchReviews = async () => {
        //     const reviews = await getReviewsByVendor(showToast);
        //     setUserReviews(reviews);
        //     getProductList();
        // };
        // fetchReviews();
    }, []);

    useEffect(() => {
        if (productList.length > 0 && !selectedProductId) {
            setSelectedProductId(productList[0].id); // Set first product as default if none selected
        }
    }, [productList]);

    useEffect(() => {
        if (selectedProductId) {
            const filteredReviews = userReviews.filter(
                (review) => review.product.id === selectedProductId
            );
            setReviewsData(filteredReviews);
        }
    }, [selectedProductId, userReviews]);

    function getProductList() {
        if (!userReviews) return;
        // Extract unique products from reviews
        const products = userReviews.reduce((acc, review) => {
            const { id, name } = review.product;
            if (!acc.some((p) => p.id === id)) {
                acc.push({ id, name });
            }
            return acc;
        }, []);

        setProductList(products);
    }

    const handleSearch = (e) => {
        setSearchQuery(e.target.value.toLowerCase());
    };

    const handleReplyClick = (review) => {
        setSelectedReview(review); //Sets the review, so that we can get the id to it
        setShowReplyModal(true); // Show the modal when a reply button is clicked
    };

    const handleReplySubmit = async () => {
        const response = await respondToReview(selectedReview.id, replyText);
        setShowReplyModal(false);
    };

    const filteredReviews = reviewsData.filter(
        (review) =>
            review.comment.toLowerCase().includes(searchQuery) ||
            review.product.name.toLowerCase().includes(searchQuery)
    );

    return (
        <div className="mt-[20px] flex flex-col">
            <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center">
                <SearchBar handleSearch={handleSearch} text={"Search your reviews"} />
                <div className="w-full h-[40px] flex justify-end mt-[20px] lg:mt-0">
                    {userReviews && userReviews.length > 0 && (
                        <select
                            className="w-[208px] h-[40px] text-white px-2 py-auto text-[18px] bg-charmOrange hover:text-integrationRequestTextHover hover:bg-charmHover font-proximanova whitespace-nowrap"
                            onChange={(e) => setSelectedProductId(e.target.value)}
                            value={selectedProductId}
                        >
                            {productList.map((product) => (
                                <option key={product.id} value={product.id}>
                                    {product.name}
                                </option>
                            ))}
                        </select>
                    )}
                </div>
            </div>

            {userReviews && userReviews.length > 0 ? (
                <>
                    {/* Display Reviews */}
                    <div className="mt-[20px]">
                        {filteredReviews.length === 0 ? (
                            <p className="text-center text-[18px] font-proximanova text-[#505050]">No reviews yet.
                            </p>
                        ) : (
                            filteredReviews.map((review) => (
                                <div key={review.id} className="bg-white p-4 mb-4 shadow-sm">
                                    <div className="flex justify-between">
                                        <div className="font-bold">
                                            <strong>{review.practice_user_name}</strong>
                                            <p className="text-gray-700">{review.practice_user_email}</p>
                                        </div>
                                        <div className="xs:hidden sm:block text-yellow-500">
                                            {'⭐'.repeat(review.rating)}
                                            <span className="text-gray-600">({review.rating}/5)</span>
                                        </div>
                                    </div>
                                    <div className="xs:block sm:hidden text-yellow-500">
                                        {'⭐'.repeat(review.rating)}
                                        <span className="text-gray-600">({review.rating}/5)</span>
                                    </div>
                                    <div className="xs:line-clamp-2 sm:line-clamp-5 mt-2 text-base">
                                        <p>{review.comment}</p>
                                    </div>

                                    <div className="mt-2 text-sm text-gray-500">
                                        <small>{new Date(review.created_at).toLocaleString()}</small>
                                    </div>

                                    {review.vendor_response && (
                                        <div className="mt-4 text-sm italic text-gray-600">
                                            <strong>Vendor Response:</strong>
                                            <p>{review.vendor_response}</p>
                                        </div>
                                    )}

                                    <button
                                        className="bg-[#9A016A] text-white py-2 px-4 border-none cursor-pointer mt-4"
                                        onClick={() => handleReplyClick(review)}
                                    >
                                        Reply
                                    </button>
                                </div>

                            ))
                        )}
                    </div>

                    {/* Reply Modal */}
                    <Modal show={showReplyModal} onHide={() => setShowReplyModal(false)}>
                        <Modal.Header closeButton>
                            <Modal.Title>Reply to Review</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <textarea
                                className="form-control"
                                rows="4"
                                value={replyText}
                                onChange={(e) => setReplyText(e.target.value)}
                                placeholder="Write your reply..."
                            ></textarea>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => setShowReplyModal(false)}>
                                Cancel
                            </Button>
                            <Button variant="primary" onClick={handleReplySubmit}>
                                Submit Reply
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </>) : (
                <p className="mt-20 text-center text-[18px] font-proximanova text-[#505050]">No reviews yet.</p>
            )
            }
        </div>
    );
};

export default Reviews;
